import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery, post } from "../helpers.ts";

export interface NewOutboundEmailRequest {
  customerId?: string;
  customerName?: string;
  channelId?: number;
  channelName?: string;
  customerEmailAddress?: string | null;
  channelEmailAddress: string | null;
  threadId?: string | null;
}

const emailHubApi = createApi({
  reducerPath: "emailHub",
  baseQuery: apiBaseQuery("/email"),
  endpoints: builder => ({
    initiateEmailConversation: builder.mutation<void, NewOutboundEmailRequest>({
      query: body => post("/initiate", body),
    }),
  }),
});

export const { useInitiateEmailConversationMutation } = emailHubApi;
export default emailHubApi;
